// extracted by mini-css-extract-plugin
export var answer = "bK_hn";
export var arrow = "bK_9";
export var body = "bK_c";
export var category = "bK_cK";
export var contactIcons = "bK_hg";
export var current = "bK_fm";
export var fade = "bK_hk";
export var footer = "bK_ch";
export var footerText = "bK_cj";
export var icon = "bK_bv";
export var iconContainer = "bK_cs";
export var issue = "bK_hm";
export var issueContainer = "bK_hj";
export var issueText = "bK_hl";
export var issues = "bK_hh";
export var left = "bK_bN";
export var padding = "bK_dD";
export var right = "bK_cl";
export var section = "bK_d";
export var selectors = "bK_fs";
export var subtitle = "bK_cV";
export var title = "bK_h";